/**
 * Product-only recommendation image behavior.
 * Loaded only on product templates by the theme layouts.
 */
  /**
   * Hide Recommendation Images from Search Engine Crawlers
   * Prevents equipment recommendation images from appearing in Google search results
   * while keeping them visible to users after page load
   */

  (function() {
    'use strict';

    // Configuration
    const CONFIG = {
      // Product handles that should hide recommendation images
      targetProducts: [
        'jlg-part-8528074s-paint-skytrak-orange-gallon',
        'jlg-part-7026901-kit-seat-cushion',
        'light-led-ind-red-12v-nh-genie-part-824879gt-or-824879',
        'handle-knob-speed-cont-jlg-part-2560136',
        'controller-joystick-dual-axis-jlg-part-1600452'

      ],

      // Delay before showing images (milliseconds)
      showDelay: 2000,

      // Fallback delay (in case primary method fails)
      fallbackDelay: 5000,

      // Selectors
      selectors: {
        recommendationSection: '.product-recommendations',
        recommendationImages: '.product-recommendations img',
        imageWrappers: '.product-recommendations .product-item__image-wrapper'
      }
    };

    /**
     * Get current product handle from URL or meta tags
     */
    function getCurrentProductHandle() {
      // Method 1: Try to get from URL path
      const pathMatch = window.location.pathname.match(/\/products\/([^\/\?]+)/);
      if (pathMatch) {
        return pathMatch[1];
      }

      // Method 2: Try to get from meta tags or global variables
      if (window.theme && window.theme.productHandle) {
        return window.theme.productHandle;
      }

      // Method 3: Try to get from canonical URL
      const canonical = document.querySelector('link[rel="canonical"]');
      if (canonical) {
        const canonicalMatch = canonical.href.match(/\/products\/([^\/\?]+)/);
        if (canonicalMatch) {
          return canonicalMatch[1];
        }
      }

      return null;
    }

    /**
     * Check if current product should hide recommendation images
     */
    function shouldHideRecommendationImages() {
      const currentHandle = getCurrentProductHandle();
      return currentHandle && CONFIG.targetProducts.includes(currentHandle);
    }

    /**
     * Create and inject CSS to hide images
     */
    function injectHidingCSS() {
      const style = document.createElement('style');
      style.id = 'hide-recommendation-images-css';
      style.textContent = `
        ${CONFIG.selectors.recommendationImages} {
          display: none !important;
          visibility: hidden !important;
        }

        ${CONFIG.selectors.imageWrappers} {
          background: #f5f5f5 !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          min-height: 200px !important;
          position: relative !important;
        }

        ${CONFIG.selectors.imageWrappers}:before {
          content: "Loading..." !important;
          color: #999 !important;
          font-size: 14px !important;
          position: absolute !important;
          top: 50% !important;
          left: 50% !important;
          transform: translate(-50%, -50%) !important;
          z-index: 1 !important;
        }
      `;

      document.head.appendChild(style);
      return style;
    }

    /**
     * Remove hiding CSS and show images
     */
    function showRecommendationImages() {
      // Remove the hiding CSS
      const hidingStyle = document.getElementById('hide-recommendation-images-css');
      if (hidingStyle) {
        hidingStyle.remove();
      }

      // Force show images with inline styles
      const images = document.querySelectorAll(CONFIG.selectors.recommendationImages);
      const wrappers = document.querySelectorAll(CONFIG.selectors.imageWrappers);

      images.forEach(img => {
        img.style.display = '';
        img.style.visibility = '';
        img.style.opacity = '1';
        img.style.transition = 'opacity 0.3s ease';
      });

      wrappers.forEach(wrapper => {
        wrapper.style.background = '';
        wrapper.style.minHeight = '';
        wrapper.style.display = '';
        wrapper.style.alignItems = '';
        wrapper.style.justifyContent = '';
        wrapper.style.position = '';
      });

      console.log('Recommendation images are now visible');
    }

    /**
     * Main initialization function
     */
    function init() {
      // Only run on product pages
      if (!window.location.pathname.includes('/products/')) {
        return;
      }

      // Check if this product should hide recommendation images
      if (!shouldHideRecommendationImages()) {
        return;
      }

      console.log('Hiding recommendation images for SEO purposes...');

      // Inject CSS to hide images immediately
      const hidingStyle = injectHidingCSS();

      // Set timeout to show images after delay
      setTimeout(() => {
        showRecommendationImages();
      }, CONFIG.showDelay);

      // Fallback timeout in case something goes wrong
      setTimeout(() => {
        if (document.getElementById('hide-recommendation-images-css')) {
          console.warn('Fallback: Showing recommendation images after extended delay');
          showRecommendationImages();
        }
      }, CONFIG.fallbackDelay);

      // Also show images when user interacts with the page
      const interactionEvents = ['click', 'scroll', 'touchstart', 'keydown'];
      let hasInteracted = false;

      const handleInteraction = () => {
        if (!hasInteracted && document.getElementById('hide-recommendation-images-css')) {
          hasInteracted = true;
          setTimeout(() => {
            showRecommendationImages();
          }, 500);

          // Remove event listeners
          interactionEvents.forEach(event => {
            document.removeEventListener(event, handleInteraction);
          });
        }
      };

      interactionEvents.forEach(event => {
        document.addEventListener(event, handleInteraction, { passive: true });
      });
    }

    /**
     * Wait for DOM to be ready
     */
    function domReady() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
      } else {
        init();
      }
    }

    // Start the script
    domReady();

    // Export for debugging (optional)
    window.hideRecommendationImages = {
      init: init,
      show: showRecommendationImages,
      getCurrentHandle: getCurrentProductHandle,
      config: CONFIG
    };

  })();
